import { SvgIcon } from "@mui/material";
import React from "react";

const ArrowDownChevron = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 25">
    <path
      d="M21.6726 7.66553L12.7104 16.6277C12.3199 17.0183 11.6867 17.0183 11.2962 16.6277L2.33398 7.66553"
      fill="none"
      stroke="inherit"
      width="24"
      height="25"
      strokeWidth="2.7"
      strokeLinecap="round"
      style={{ fill: "none" }} 
    />
  </SvgIcon>
);
export default ArrowDownChevron;
